import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem("token")}` };
}

export async function listSkillAgentProjects(params = {}) {
  const res = await axios.get(`${API_URL}/api/skill-agent-projects`, {
    headers: authHeaders(),
    params,
  });
  return res.data;
}

/** Raíces ligeras: temporada → cliente → proyectos con conteos. */
export async function listSkillAgentProjectTreeRoots() {
  const res = await axios.get(
    `${API_URL}/api/skill-agent-projects/tree-roots`,
    { headers: authHeaders() },
  );
  return res.data;
}

export async function getSkillAgentProjectBundle(projectId) {
  const res = await axios.get(
    `${API_URL}/api/skill-agent-projects/${projectId}/bundle`,
    { headers: authHeaders() },
  );
  return res.data;
}

/** Resolver ProjectId desde una reunión (?meeting= al refrescar Compás). */
export async function getSkillAgentProjectByMeeting(meetingId) {
  const res = await axios.get(
    `${API_URL}/api/skill-agent-projects/by-meeting/${meetingId}`,
    { headers: authHeaders() },
  );
  return res.data;
}

export async function createSkillAgentProject(body) {
  const res = await axios.post(`${API_URL}/api/skill-agent-projects`, body, {
    headers: authHeaders(),
  });
  return res.data;
}

export async function updateSkillAgentProject(projectId, body) {
  const res = await axios.patch(
    `${API_URL}/api/skill-agent-projects/${projectId}`,
    body,
    { headers: authHeaders() },
  );
  return res.data;
}

/** Soft-delete. 409 NOT_EMPTY si el proyecto tiene reuniones o piezas. */
export async function deleteSkillAgentProject(projectId) {
  const res = await axios.delete(
    `${API_URL}/api/skill-agent-projects/${projectId}`,
    { headers: authHeaders() },
  );
  return res.data;
}

export async function syncSkillAgentProjectsFromMeetings() {
  const res = await axios.post(
    `${API_URL}/api/skill-agent-projects/sync-from-meetings`,
    {},
    { headers: authHeaders() },
  );
  return res.data;
}
